import moment from "moment";
import DatePicker from "components/CSRAdmin/FormElements/DatePicker";
import { useTranslation } from "react-i18next";

export default function StartDate({ setValue, register, errors, isDisabled }) {
  const { t } = useTranslation();
  return (
    <DatePicker
      setValue={setValue}
      labelName={t("AgentCSR-Admin-StartDate-label")}
      register={register}
      name="startDate"
      min={moment().format("YYYY-MM-DD").toString()}
      errors={errors}
      validationsProps={{
        required: "This is a required field.",
        validate: {
          futureDate: (value) =>
            moment(value).isSameOrAfter(moment().format("YYYY-MM-DD")) ||
            isDisabled
              ? null
              : "Must be a future date.",
        },
      }}
      validationMessage={errors?.startDate?.message}
      isDisabled={isDisabled}
    />
  );
}
